import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterModule } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { SlideRightDirective } from '../../../directives/animations/slide-right.directive';
@Component({
  selector: 'section[app-home-style]',
  imports: [MatButtonModule, RouterModule, SlideRightDirective],
  templateUrl: './home-style.html',
  styleUrl: './home-style.scss',
})
export class HomeStyle {
  get appname(): string {
    return environment.appname;
  }
}
